export const APP_ROUTES = {
  ABOUT: '/articles/about',
  ADD_GIFTCARD: '/add-giftcard/:token',
  ADVICE_PAGES_ARCHIVE: '/fakta-och-rad',
  ADVICE_PAGES_LANDING: '/fakta-och-rad/:slugID',
  APP: '/app',
  ASSOCIATION_PAGES_ARCHIVE: '/bransch-organisationer',
  ASSOCIATION_PAGES_LANDING: '/bransch-organisationer/:slugID',
  BLOG: '/blogg',
  BLOG_CATEGORY: '/blogg/c/:slug/:page?',
  BLOG_LIST: '/blogg/list/:page?',
  BLOG_SINGLE_POST: '/blogg/p/:slugId/',
  BOOKING_CALENDAR: '/boka-tjanst/:placeSlugId/:serviceSlugId',
  BOOKING_CHECKOUT: '/booking/checkout',
  BOOKING_CHECKOUT_KLARNA: '/booking/checkout/klarna',
  BOOKING_CHECKOUT_QLIRO: '/booking/checkout/qliro',
  BOOKING_CHECKOUT_VALIDATE_3DS: '/booking/checkout/validate-3ds-redirect',
  BOOKING_CHECKOUT_VALIDATE_SWISH: '/booking/checkout/validate-swish-redirect',
  BOOKING_CONFIRMATION: '/booking/confirmation',
  BOOKING_PREPAY_CHECKOUT: '/booking/checkout/:bookingId',
  BOOKING_PREPAY_CHECKOUT_KLARNA: '/booking/checkout/:bookingId/klarna',
  BOOKING_PREPAY_CHECKOUT_QLIRO: '/booking/checkout/:bookingId/qliro',
  BUNDLE_CHECKOUT: '/bundles/checkout/:placeId?/:bundleId?',
  BUNDLE_CHECKOUT_QLIRO: '/bundles/checkout/qliro',
  BUNDLE_CONFIRMATION: '/bundles/confirmation',
  CANCEL_BY_CODE: '/cancel',
  COOKIE_POLICY: '/articles/cookies',
  DEALS: '/deals',
  DOWNLOAD_APP: '/download-app',
  ETHICAL_POLICY: '/articles/ethical-policy',
  FAQ: '/faq-vanliga-fragor',
  GENERATE_BANNER: '/generate-banner',
  GIFTCARD_CHECKOUT: '/presentkort/:campaign?',
  GIFTCARD_CHECKOUT_QLIRO: '/presentkort/qliro',
  GIFTCARD_CONFIRMATION: '/giftcard/confirmation/:id?',
  GIFTCARD_USE: '/giftcards',
  GOTO: '/goto/:id/:group?',
  HOME: '/',
  INJECTION_NOTICE: '/articles/injection-notice',
  MOBILE_SEARCH: '/search',
  MY_BOKNINGS_DETAILS: '/bokning/:id',
  MY_BOOKINGS: '/bokningar',
  MY_BOOKINGS_FINISHED: '/bokningar/tidigare',
  MY_BUNDLES_DETAILS: '/klippkortdetaljer/:id',
  MY_BUNDLES_EXPIRED: '/klippkort/forfallen',
  MY_BUNDLES_USED: '/klippkort/anvand',
  MY_BUNDLES_VALID: '/klippkort/giltig',
  MY_FAVORITES: '/favoriter',
  MY_PROFILE: '/my-profile',
  NEWSLETTER: '/newsletter',
  ORDERS_CONFIRMATION: '/orders/:bookingId/booking-confirmation',
  PAYMENT_METHODS: '/betalningsmetoder',
  PLACE_GIFTCARD_CHECKOUT: '/places/:slugId/giftcard/checkout',
  PLACE_GIFTCARD_CHECKOUT_QLIRO: '/places/:slugId/giftcard/checkout/qliro',
  PLACE_VALUECARD_CHECKOUT: '/places/:slugId/valuecard/checkout',
  PLACE_VALUECARD_CHECKOUT_QLIRO: '/places/:slugId/valuecard/checkout/qliro',
  PLACE_PAGE: '/places/:slugId',
  PLACE_PLACECARD_CONFIRMATION: '/places/:slugId/placecard/confirmation/:id',
  PLACE_VALUECARD_BUY: '/places/:slugId/valuecards/buy',
  PLACE_VALUECARD_CONFIRMATION: '/places/:slugId/valuecard/confirmation/:id',
  PORTAL: '/portal/:slug/:id/:group?',
  PRIVACY_POLICY: '/articles/privacy-policy',
  PROFILE_PLACE_PAGE: '/profile-places/:slugId',
  REVIEWS_BY_USER: '/reviews/:userId/:bookingId',
  REVIEWS_REDIRECT: '/reviews-redirect',
  REVIEWS_SUPPORT: '/reviews-support',
  REVIEWS_SUPPORT_REMINDERS: '/reviews-support-reminders',
  REVIEWS_SUPPORT_USERS: '/reviews-support-users',
  REVIEWS_UNSUBSCRIBE: '/reviews/unsubscribe/:emailHash',
  SEARCH_NOTICE: '/articles/search-notice',
  SECURITY_ACKNOWLEDGEMENTS: '/articles/security-acknowledgements',
  SECURITY_POLICY: '/articles/security-policy',
  SERP: '/:q/:location',
  SISTA_MINUTEN_SERP: '/sistaminuten/:q?/:location?',
  SERVICES_AT_HOME: '/services-at-home',
  SUPPORT: '/support',
  SUPPORT_FORM: '/support/form',
  SUPPORT_FORM_SUBMITTED: '/support/form-submitted',
  TERMS: '/articles/terms',
  TERMS_BOOKING_CONSUMER: '/articles/terms-booking-consumer',
  TERMS_GIFTCARD_CONSUMER: '/articles/terms-giftcard-consumer',
  TERMS_ONLINE_PAYMENT: '/articles/terms-online-payment',
  UNSUBSCRIBE: '/unsubscribe/:emailHash/:deliveryId?',
  VALIDATE_COF_PAYMENT: '/validate-cof-payment-redirect/:type/:id/:placeId?',
  VALIDATE_QLIRO_PAYMENT: '/validate-qliro-payment',
  VALIDATE_SWISH_PAYMENT: '/validate-swish-payment-redirect/:type/:id/:placeId?',
  WAITING_LIST_SUCCESS: '/waiting-list-success',
  WELLNESSCARD_CHECKOUT: '/friskvardskort/:campaign?',
  WELLNESSCARD_CHECKOUT_QLIRO: '/friskvardskort/qliro',
} as const;

function buildPath(
  pattern: (typeof APP_ROUTES)[keyof typeof APP_ROUTES],
  params: Record<string, string | number | undefined> = {},
) {
  const filled = pattern.replace(/:([A-Za-z0-9_]+)\??/g, (_, key) => {
    const v = params[key];
    return v === undefined || v === null ? '' : encodeURIComponent(String(v));
  });

  const collapsed = filled.replace(/\/{2,}/g, '/');
  const cleaned = collapsed !== '/' ? collapsed.replace(/\/$/, '') : '/';
  return cleaned;
}

/** use these for any <Link to={...}> */
export const ROUTE_BUILDER = {
  home: () => APP_ROUTES.HOME,
  mobileSearch: () => APP_ROUTES.MOBILE_SEARCH,
  myProfile: () => APP_ROUTES.MY_PROFILE,
  downloadApp: () => APP_ROUTES.DOWNLOAD_APP,
  app: () => APP_ROUTES.APP,
  myBookings: () => APP_ROUTES.MY_BOOKINGS,
  myFavorites: () => APP_ROUTES.MY_FAVORITES,
  cancelByCode: () => APP_ROUTES.CANCEL_BY_CODE,
  deals: () => APP_ROUTES.DEALS,
  paymentMethods: () => APP_ROUTES.PAYMENT_METHODS,
  terms: () => APP_ROUTES.TERMS,
  termsBookingConsumer: () => APP_ROUTES.TERMS_BOOKING_CONSUMER,
  termsGiftcardConsumer: () => APP_ROUTES.TERMS_GIFTCARD_CONSUMER,
  termsOnlinePayment: () => APP_ROUTES.TERMS_ONLINE_PAYMENT,
  blog: () => APP_ROUTES.BLOG,
  giftcardCheckoutQliro: () => APP_ROUTES.GIFTCARD_CHECKOUT_QLIRO,
  giftcardUse: () => APP_ROUTES.GIFTCARD_USE,
  wellnesscardCheckoutQliro: () => APP_ROUTES.WELLNESSCARD_CHECKOUT_QLIRO,
  adviceArchive: () => APP_ROUTES.ADVICE_PAGES_ARCHIVE,
  associationArchive: () => APP_ROUTES.ASSOCIATION_PAGES_ARCHIVE,
  ordersConfirmationRoot: () => APP_ROUTES.BUNDLE_CONFIRMATION,
  cookiePolicy: () => APP_ROUTES.COOKIE_POLICY,
  ethicalPolicy: () => APP_ROUTES.ETHICAL_POLICY,
  privacyPolicy: () => APP_ROUTES.PRIVACY_POLICY,
  securityPolicy: () => APP_ROUTES.SECURITY_POLICY,
  securityAcknowledgements: () => APP_ROUTES.SECURITY_ACKNOWLEDGEMENTS,
  injectionNotice: () => APP_ROUTES.INJECTION_NOTICE,
  searchNotice: () => APP_ROUTES.SEARCH_NOTICE,
  reviewsRedirect: () => APP_ROUTES.REVIEWS_REDIRECT,
  support: () => APP_ROUTES.SUPPORT,
  supportForm: () => APP_ROUTES.SUPPORT_FORM,
  supportFormSubmitted: () => APP_ROUTES.SUPPORT_FORM_SUBMITTED,
  reviewsSupport: () => APP_ROUTES.REVIEWS_SUPPORT,
  reviewsSupportUsers: () => APP_ROUTES.REVIEWS_SUPPORT_USERS,
  reviewsSupportReminders: () => APP_ROUTES.REVIEWS_SUPPORT_REMINDERS,
  faq: () => APP_ROUTES.FAQ,
  about: () => APP_ROUTES.ABOUT,
  newsletter: () => APP_ROUTES.NEWSLETTER,
  waitingListSuccess: () => APP_ROUTES.WAITING_LIST_SUCCESS,
  servicesAtHome: () => APP_ROUTES.SERVICES_AT_HOME,
  generateBanner: () => APP_ROUTES.GENERATE_BANNER,
  bookingCheckout: () => APP_ROUTES.BOOKING_CHECKOUT,
  bookingCheckoutValidate3DS: () => APP_ROUTES.BOOKING_CHECKOUT_VALIDATE_3DS,
  bookingCheckoutValidateSwish: () => APP_ROUTES.BOOKING_CHECKOUT_VALIDATE_SWISH,
  bookingCheckoutKlarna: () => APP_ROUTES.BOOKING_CHECKOUT_KLARNA,
  bookingCheckoutQliro: () => APP_ROUTES.BOOKING_CHECKOUT_QLIRO,
  bookingConfirmation: () => APP_ROUTES.BOOKING_CONFIRMATION,
  validateQliroPayment: () => APP_ROUTES.VALIDATE_QLIRO_PAYMENT,
  bundleCheckoutQliro: () => APP_ROUTES.BUNDLE_CHECKOUT_QLIRO,
  bundleConfirmation: () => APP_ROUTES.BUNDLE_CONFIRMATION,

  // With params
  placePage: (slugId: string) => buildPath(APP_ROUTES.PLACE_PAGE, { slugId }),
  placeGiftcardCheckout: (slugId: string, type: string) =>
    buildPath(APP_ROUTES.PLACE_GIFTCARD_CHECKOUT, { slugId, type }),
  placeGiftcardCheckoutQliro: (slugId: string) => buildPath(APP_ROUTES.PLACE_GIFTCARD_CHECKOUT_QLIRO, { slugId }),
  placeValuecardCheckoutQliro: (slugId: string) => buildPath(APP_ROUTES.PLACE_VALUECARD_CHECKOUT_QLIRO, { slugId }),
  placeValuecardConfirmation: (slugId: string, id: string | number) =>
    buildPath(APP_ROUTES.PLACE_VALUECARD_CONFIRMATION, { slugId, id }),
  placePlacecardConfirmation: (slugId: string, id: string | number) =>
    buildPath(APP_ROUTES.PLACE_PLACECARD_CONFIRMATION, { slugId, id }),
  placeValuecardBuy: (slugId: string) => buildPath(APP_ROUTES.PLACE_VALUECARD_BUY, { slugId }),
  profilePlacePage: (slugId: string) => buildPath(APP_ROUTES.PROFILE_PLACE_PAGE, { slugId }),
  portal: (slug: string, id: string, group?: string) => buildPath(APP_ROUTES.PORTAL, { slug, id, group }),
  goto: (id: string, group?: string) => buildPath(APP_ROUTES.GOTO, { id, group }),
  bookingCalendar: (placeSlugId: string, serviceSlugId: string) =>
    buildPath(APP_ROUTES.BOOKING_CALENDAR, { placeSlugId, serviceSlugId }),
  bookingPrepayCheckout: (bookingId: string) => buildPath(APP_ROUTES.BOOKING_PREPAY_CHECKOUT, { bookingId }),
  bookingPrepayCheckoutKlarna: (bookingId: string) =>
    buildPath(APP_ROUTES.BOOKING_PREPAY_CHECKOUT_KLARNA, { bookingId }),
  bookingPrepayCheckoutQliro: (bookingId: string) => buildPath(APP_ROUTES.BOOKING_PREPAY_CHECKOUT_QLIRO, { bookingId }),
  validateSwishPayment: (type: string, id: string, placeId?: string) =>
    buildPath(APP_ROUTES.VALIDATE_SWISH_PAYMENT, { type, id, placeId }),
  validateCofPayment: (type: string, id: string, placeId?: string) =>
    buildPath(APP_ROUTES.VALIDATE_COF_PAYMENT, { type, id, placeId }),
  bundleCheckout: (placeId?: string, bundleId?: string) => buildPath(APP_ROUTES.BUNDLE_CHECKOUT, { placeId, bundleId }),
  myBundlesDetails: (id: string) => buildPath(APP_ROUTES.MY_BUNDLES_DETAILS, { id }),
  myBokningsDetails: (id: string) => buildPath(APP_ROUTES.MY_BOKNINGS_DETAILS, { id }),
  blogList: (page?: string | number) => buildPath(APP_ROUTES.BLOG_LIST, { page: page?.toString() }),
  blogCategory: (slug: string, page?: string | number) =>
    buildPath(APP_ROUTES.BLOG_CATEGORY, { slug, page: page?.toString() }),
  blogPost: (slugId: string) => buildPath(APP_ROUTES.BLOG_SINGLE_POST, { slugId }),
  giftcardCheckout: (campaign?: string) => buildPath(APP_ROUTES.GIFTCARD_CHECKOUT, { campaign }),
  giftcardConfirmation: (id?: number | string) => buildPath(APP_ROUTES.GIFTCARD_CONFIRMATION, { id }),
  wellnesscardCheckout: (campaign?: string) => buildPath(APP_ROUTES.WELLNESSCARD_CHECKOUT, { campaign }),
  addGiftcard: (token: string) => buildPath(APP_ROUTES.ADD_GIFTCARD, { token }),
  adviceLanding: (slugID: string) => buildPath(APP_ROUTES.ADVICE_PAGES_LANDING, { slugID }),
  associationLanding: (slugID: string) => buildPath(APP_ROUTES.ASSOCIATION_PAGES_LANDING, { slugID }),
  ordersConfirmation: (bookingId: string) => buildPath(APP_ROUTES.ORDERS_CONFIRMATION, { bookingId }),
  reviewsUnsubscribe: (emailHash: string) => buildPath(APP_ROUTES.REVIEWS_UNSUBSCRIBE, { emailHash }),
  reviewsByUser: (userId: string, bookingId: string) => buildPath(APP_ROUTES.REVIEWS_BY_USER, { userId, bookingId }),
  unsubscribe: (emailHash: string, deliveryId?: string) => buildPath(APP_ROUTES.UNSUBSCRIBE, { emailHash, deliveryId }),
  serp: (q: string, location: string) => buildPath(APP_ROUTES.SERP, { q, location }),
  sistaMinutenSerp: (q?: string, location?: string) => buildPath(APP_ROUTES.SISTA_MINUTEN_SERP, { q, location }),
};
